let initialized = false

export function initMetaPixel(): void {
  if (initialized) return
  initialized = true

  const pixelScript = document.createElement('script')
  pixelScript.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '1272881488269006');
    fbq('track', 'PageView');
  `
  document.head.appendChild(pixelScript)

  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src =
    'https://www.facebook.com/tr?id=1272881488269006&ev=PageView&noscript=1'
  document.body.appendChild(img)
}

export function trackAddToCart(): void {
  // Always fire image pixel (most reliable)
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src =
    'https://www.facebook.com/tr?id=1272881488269006&ev=AddToCart&cd[content_name]=The+Nervous+System+Reset+for+Overstimulated+Women&cd[content_type]=product&cd[value]=6.39&cd[currency]=USD&noscript=1'
  document.body.appendChild(img)

  // Also try fbq if available
  try {
    const w = window as any
    if (typeof w.fbq === 'function') {
      w.fbq('track', 'AddToCart', {
        content_name: 'The Nervous System Reset for Overstimulated Women',
        content_type: 'product',
        value: 6.39,
        currency: 'USD',
      })
    }
  } catch (e) {
    // silently fail
  }
}

const CHECKOUT_URL = 'https://www.cleverpockets.com/cart/45007111815304:1'

export function handleCheckoutClick(): void {
  trackAddToCart()
  setTimeout(() => {
    window.open(CHECKOUT_URL, '_blank')
  }, 350)
}
